
import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Mail, Phone, Clock } from 'lucide-react';

const ContactOptions = () => {
  const contactMethods = [
    {
      icon: <Phone className="h-5 w-5" />,
      title: "Call Us",
      content: "+9613102322",
      color: "bg-gray-50",
      textColor: "text-gray-700",
      iconColor: "text-gray-500",
      delay: 0
    },
    {
      icon: <Mail className="h-5 w-5" />,
      title: "Email Us",
      content: "hello@nextgenstartup.ai",
      color: "bg-gray-50",
      textColor: "text-gray-700",
      iconColor: "text-gray-500",
      delay: 0.1
    },
    {
      icon: <MapPin className="h-5 w-5" />,
      title: "Our Location",
      content: "The Cloud (We're Everywhere!)",
      color: "bg-gray-50",
      textColor: "text-gray-700",
      iconColor: "text-gray-500",
      delay: 0.2
    },
    {
      icon: <Clock className="h-5 w-5" />,
      title: "Business Hours",
      content: "24/7 - AI Never Sleeps",
      color: "bg-gray-50",
      textColor: "text-gray-700",
      iconColor: "text-gray-500",
      delay: 0.3
    }
  ];

  return (
    <div className="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-4 gap-3 mb-8">
      {contactMethods.map((method, index) => (
        <motion.div
          key={index}
          className={`${method.color} p-3 rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-all duration-300`}
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ 
            duration: 0.4, 
            delay: method.delay, 
            type: "spring", 
            stiffness: 100 
          }}
          whileHover={{ 
            y: -3, 
            boxShadow: "0 10px 15px -5px rgba(0, 0, 0, 0.08)" 
          }}
        >
          <div className="flex flex-col sm:flex-row items-center sm:items-start space-y-2 sm:space-y-0 sm:space-x-2 text-center sm:text-left">
            <div className={`${method.iconColor} p-2 rounded-full bg-white shadow-sm`}>
              {method.icon}
            </div>
            
            <div>
              <h4 className={`text-base font-semibold ${method.textColor}`}>{method.title}</h4>
              <p className="text-xs sm:text-sm text-gray-700 break-words">{method.content}</p>
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default ContactOptions;
